import { Outlet } from '@tanstack/react-router';
import { Sidebar } from '@/components/Sidebar';

export function AppShell() {
  return (
    <div className="flex h-dvh overflow-hidden surface-page">
      <div className="hidden md:block"><Sidebar /></div>
      <main className="min-h-0 flex-1 overflow-hidden"><Outlet /></main>
    </div>
  );
}
